"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var calcPrimaryTeamOptions_exports = {};
__export(calcPrimaryTeamOptions_exports, {
  calcPrimaryTeamOptions: () => calcPrimaryTeamOptions
});
module.exports = __toCommonJS(calcPrimaryTeamOptions_exports);
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
function calcPrimaryTeamOptions(props) {
  const { users, teams, projectId, initialTeamId, primarySurveyor, primaryTeamId } = props;
  const initialTeam = findTeam(initialTeamId, teams);
  const primaryTeam = findTeam(primaryTeamId, teams);
  const primarySurveyorUser = findUser(primarySurveyor, users);
  const selectedSection = {
    heading: "Selected Team",
    options: primaryTeamId != null ? [teamIdToOption(primaryTeamId, primaryTeam, "selected-team")] : []
  };
  const seenTeamIds = new Set(primaryTeamId != null ? [primaryTeamId] : []);
  const surveyorTeamIds = new Set(
    primarySurveyorUser != null ? (0, import_util.filterAndMap)(primarySurveyorUser.roles, import_types.roleTeamId) : []
  );
  const restSections = teams.reduce(
    (teamSections, team) => {
      if (team.id !== primaryTeamId) {
        const [index, sectionKey] = !team.projectIds.includes(projectId) ? [2, "other-workspace-teams"] : surveyorTeamIds.has(team.id) ? [0, "surveyor-teams"] : [1, "other-project-teams"];
        teamSections.splice(index, 1, {
          ...teamSections[index],
          options: teamSections[index].options.concat(teamToOption(team, sectionKey))
        });
      }
      seenTeamIds.add(team.id);
      return teamSections;
    },
    [
      { heading: "Surveyor's Teams", options: [] },
      { heading: "Other Project Teams", options: [] },
      { heading: "Other Workspace Teams", options: [] }
    ]
  );
  const originalSection = {
    heading: "Original Team",
    options: initialTeamId != null && !seenTeamIds.has(initialTeamId) ? [teamIdToOption(initialTeamId, initialTeam, "original-team")] : []
  };
  return [
    {
      heading: "No Team",
      options: [{ label: "No Team", value: null, key: "no-team" }]
    },
    selectedSection,
    originalSection,
    ...restSections
  ].filter(({ options }) => options.length > 0);
}
function teamIdToOption(teamId, team, keyPrefix) {
  return {
    label: team?.name == null ? `Team ${teamId}` : team.name,
    value: teamId,
    key: keyPrefix != null ? `${keyPrefix}.${teamId}` : teamId
  };
}
function teamToOption(team, keyPrefix) {
  return {
    label: team.name,
    value: team.id,
    key: keyPrefix != null ? `${keyPrefix}.${team.id}` : team.id
  };
}
function findTeam(teamId, teams) {
  return teamId == null ? null : teams.find((team) => team.id === teamId) ?? null;
}
function findUser(ref, users) {
  return ref?.userId == null ? null : users.find((user) => user.id === ref.userId) ?? null;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  calcPrimaryTeamOptions
});
//# sourceMappingURL=calcPrimaryTeamOptions.js.map
